/* global $ */
'use strict';

function TreatmentGallery(EVENTS) {
	var Handlebars = require('handlebars');
	var PubSub = require('pubsub-js');

	var visual = $.t('visual', {returnObjectTrees: true});
	var data = composeData(visual);
	var $gallery = $('.sag-horozontal-gallery');
	if ($gallery.length) {
		var template = Handlebars.compile($('#sag-horizontal-gallery').html());
		$gallery.append(template(data));
	}
	var $treatment = $('.sag-horozontal-gallery__image');

	function bindEvents() {
		$treatment.on('click', function () {
			$treatment.removeClass('sag-horozontal-gallery__image--selected');
			$(this).addClass('sag-horozontal-gallery__image--selected');
			$('#treatment .next-button').attr('href', window.NIKE.urlId+'/slick/'+$(this).data('number')).removeClass('sag-button--disabled');
			PubSub.publish(EVENTS.TREATMENT_TRACKING, { obj:this, name:$(this).data('name')});
		});
	}

	function composeData(data) {
		var result = {
			'slides': []
		};
		var dataArray = [];

		for (var prop in data) {
			if (data.hasOwnProperty(prop)) {
				dataArray.push({
					'treatment': data[prop].treatment,
					'name': data[prop].name
				});
			}
		}

		for (var i = 0, l = dataArray.length; i < l; i++) {
			var obj = {
				'number': i,
				'src': dataArray[i].treatment,
				'name': dataArray[i].name
			};
			if (i % 2 === 0) {
				result.slides.push([obj]);
				continue;
			}
			result.slides[result.slides.length - 1].push(obj);
		}

		return result;
	}

	bindEvents();
}

module.exports = TreatmentGallery;
